import React from "react";
import { Link } from "react-router-dom";
import { JackInTheBox, Slide } from "react-awesome-reveal";
import hero1 from "../../images/edy.webp";
import cerebro from "../../images/logo.avif";
import shape from "../../images/slider/line-1.png";

const About = (props) => {
  return (
    <section className="static-hero-about" id="div">
      <div className="hero-container">
        <div className="hero-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-8 col-lg-6 col-12">
                <div className="wpo-static-hero-inner">
                  <div className="about-section-title">
                    <span>Quem está por trás da Neurodesenvolver?</span>
                  </div>
                  {/* Imagem visível apenas no mobile */}
                  <div className="static-hero-right d-lg-none">
                    <div className="static-hero-img">
                      <div className="static-hero-img-inner">
                        <img src={hero1} alt="Edy Rodrigues" />
                        <div className="hero-img-inner-boder"></div>
                      </div>
                      <div className="icon-1">
                        <img src={cerebro} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="slide-sub-title">
                    <Slide direction="up" duration="1000" triggerOnce="true">
                      <h2>Edy Rodrigues. </h2>
                    </Slide>
                  </div>
                  <div className="slide-text">
                    <Slide direction="up" duration="1500" triggerOnce="true">
                      <p>
                        Edy Rodrigues é Pedagoga, Psicanalista Clínica e
                        diretora da Edufuturo International School.
                      </p>
                      <p>
                        Criadora do Instituto Neurodesenvolver e autora do livro
                        Depois da Perda, Edy transforma dor em direção e
                        compartilha, por meio de sua vivência nas escolas, na
                        clínica e na vida, ferramentas práticas e profundas para
                        recomeçar com propósito.
                      </p>
                    </Slide>
                  </div>
                  <div className="clearfix"></div>
                  <div className="slide-btn">
                    <Slide direction="up" duration="1600" triggerOnce="true">
                      <Link
                        onClick={props.link} // Usando a prop 'link' para rolagem
                        className="theme-btn"
                      >
                        QUERO GARANTIR MEU KIT AGORA
                      </Link>
                    </Slide>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Imagem visível apenas no desktop */}
      <div className="static-hero-right d-none d-lg-block">
        <div className="static-hero-img">
          <div className="static-hero-img-inner">
            <img src={hero1} alt="Edy Rodrigues, pedagoga e psicanalista" />
            <div className="hero-img-inner-boder"></div>
          </div>
          <div className="icon-1">
            <div className="icon-img">
              <JackInTheBox direction="up" duration="2000" triggerOnce="true">
                <img src={cerebro} alt="" />
              </JackInTheBox>
            </div>
            <div className="icon-boder"></div>
          </div>
        </div>
      </div>
      <div className="shape-1">
        <svg width="696" height="839" viewBox="0 0 696 839" fill="none">
          <g opacity="0.6" filter="url(#filter0_f_221_39)">
            <circle cx="162" cy="305" r="234" />
          </g>
          <defs>
            <filter
              id="filter0_f_221_39"
              x="-372"
              y="-229"
              width="1068"
              height="1068"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="150"
                result="effect1_foregroundBlur_221_39"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="line-shape-1">
        <img src={shape} alt="" />
      </div>
    </section>
  );
};

export default About;
